import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { X } from "react-bootstrap-icons";
import { setImagePopup } from '../store/api/GetAllProduct';
const ModalProducts = () => {
    const popup = useSelector(state => state.popup?.imagePop);
    const dispatch = useDispatch();
    const handleModal = () => {
        dispatch(setImagePopup({ status: 'hide' }));
    }
    return (
        <Modal show={popup.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: 'rgb(3 149 228)' }}>تصویر کالا<span onClick={handleModal} style={{ cursor: "pointer" }}>
                <X size={20} /></span>
            </Modal.Header>
            <Modal.Body style={{backgroundColor:"#ededfb"}}>
                    {popup.image &&
                    <img src={"data:image;base64," + popup.image} alt='' style={{display:"block", margin:"auto", maxWidth:"100%"}} />}
            </Modal.Body>
        </Modal>
    )
}
export default ModalProducts;